var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isMenuHasSubMenu(_vm.menu) ? _c('div', {
    staticClass: "side-menu-item",
    class: {
      'active': _vm.isSubMenuRouteActive(_vm.menu)
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.toFirstSubMenu(_vm.menu);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.menu.title) + " "), _c('div', {
    staticClass: "side-menu-group"
  }, [_vm._l(_vm.menu.subMenus, function (eachSubMenu) {
    return [_c('sub-side-menu-entity', {
      key: eachSubMenu.name,
      attrs: {
        "menu": eachSubMenu,
        "collapse-state": _vm.collapseState
      },
      on: {
        "on-menu-close": function ($event) {
          return _vm.onMenuClose();
        }
      }
    })];
  })], 2)]) : _c('div', {
    staticClass: "side-menu-item",
    class: {
      'active': _vm.isSubRouteActive(_vm.menu)
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.transfer(_vm.menu.path);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.menu.title) + " ")]);
}
var staticRenderFns = []

export { render, staticRenderFns }